import { useMutation } from '@tanstack/react-query'
import { getProviderBannerUploadFileUrl } from '@/modules/game/api/services'
import { GetUploadFileUrlResponse } from '@/modules/operator/type'
import { UseBaseMutationOptions } from '@/core/api/type'
import { GameMutationKeys } from '@/modules/game/keys'

interface CreateFileUrlParams {
	payload: { fileExtension: string }
}

export default function useMutationCreateProviderBannerFileUrl(
	props?: UseBaseMutationOptions<GetUploadFileUrlResponse, CreateFileUrlParams>,
) {
	return useMutation({
		mutationKey: [GameMutationKeys.CreateProviderBannerFileUrl],
		mutationFn: (params) => getProviderBannerUploadFileUrl(params.payload),
		...props,
	})
}
